import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const Events = lazy(() => import('../pages/events/page'));
const Beliefs = lazy(() => import('../pages/beliefs/page'));
const CoreValues = lazy(() => import('../pages/core-values/page'));
const Resources = lazy(() => import('../pages/resources/page'));
const MenMinistry = lazy(() => import('../pages/ministries/men/page'));
const WomenMinistry = lazy(() => import('../pages/ministries/women/page'));
const YouthMinistry = lazy(() => import('../pages/ministries/youth/page'));
const ChildrenMinistry = lazy(() => import('../pages/ministries/children/page'));
const EvangelismMinistry = lazy(() => import('../pages/ministries/evangelism/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/events',
    element: <Events />,
  },
  {
    path: '/beliefs',
    element: <Beliefs />,
  },
  {
    path: '/core-values',
    element: <CoreValues />,
  },
  {
    path: '/resources',
    element: <Resources />,
  },
  {
    path: '/ministries/men',
    element: <MenMinistry />,
  },
  {
    path: '/ministries/women',
    element: <WomenMinistry />,
  },
  {
    path: '/ministries/youth',
    element: <YouthMinistry />,
  },
  {
    path: '/ministries/children',
    element: <ChildrenMinistry />,
  },
  {
    path: '/ministries/evangelism',
    element: <EvangelismMinistry />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
